// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lm-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  padding: 16px;
}

.lm-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
  border: 1px solid #e2e8f0;
  animation: lmFadeIn 0.15s ease-out;
}

@keyframes lmFadeIn {
  from { opacity: 0; transform: translateY(6px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.lm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.lm-header-main {
  min-width: 0;
  flex: 1 1;
}

.lm-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.lm-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.lm-email {
  font-size: 15px;
  color: #64748b;
  margin: 2px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lm-close {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.lm-close:hover {
  background: #f8fafc;
  color: #0f172a;
}

.lm-status {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.lm-status.active { background: #dcfce7; color: #166534; }
.lm-status.expired { background: #fee2e2; color: #991b1b; }
.lm-status.revoked { background: #f1f5f9; color: #475569; }
.lm-status.paused { background: #fef3c7; color: #92400e; }
.lm-status.deleted { background: #f3f4f6; color: #9ca3af; }

.lm-body {
  padding: 12px 16px 14px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.lm-hint {
  font-size: 13px;
  color: #64748b;
  margin: 0 0 10px;
  line-height: 1.35;
}

.lm-hint strong {
  color: #2563eb;
  font-weight: 600;
}

.lm-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 10px;
}

.lm-stat {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 10px;
  min-width: 0;
}

.lm-stat-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 2px;
}

.lm-stat-value {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lm-stat-value.danger { color: #dc2626; }
.lm-stat-value.ok { color: #059669; }
.lm-stat-value.mono {
  font-family: ui-monospace, monospace;
  font-size: 13px;
  font-weight: 500;
}

.lm-keys {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;
}

.lm-key-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  min-width: 0;
}

.lm-key-label {
  font-size: 14px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  flex-shrink: 0;
  width: 72px;
}

.lm-key-text {
  flex: 1 1;
  font-family: ui-monospace, monospace;
  font-size: 13px;
  color: #475569;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.lm-copy-btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border: none;
  background: none;
  color: #2563eb;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 2px 4px;
  flex-shrink: 0;
}

.lm-copy-btn:hover {
  color: #1d4ed8;
}

.lm-activity-title {
  font-size: 14px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 6px;
}

.lm-activity-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.lm-activity-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 5px 8px;
  background: #f8fafc;
  border-radius: 6px;
  font-size: 13px;
  color: #475569;
}

.lm-activity-item span:last-child {
  color: #94a3b8;
  flex-shrink: 0;
}

.lm-empty {
  font-size: 13px;
  color: #94a3b8;
  padding: 4px 0;
}

@media (max-width: 480px) {
  .lm-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LicenseModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wBAAwB,cAAc,EAAE;AACxC,oBAAoB,cAAc,EAAE;AACpC;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAO;EACP,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".lm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  padding: 16px;\n}\n\n.lm-modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 32px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e2e8f0;\n  animation: lmFadeIn 0.15s ease-out;\n}\n\n@keyframes lmFadeIn {\n  from { opacity: 0; transform: translateY(6px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.lm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.lm-header-main {\n  min-width: 0;\n  flex: 1;\n}\n\n.lm-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.lm-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.lm-email {\n  font-size: 15px;\n  color: #64748b;\n  margin: 2px 0 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lm-close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.lm-close:hover {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.lm-status {\n  display: inline-flex;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.lm-status.active { background: #dcfce7; color: #166534; }\n.lm-status.expired { background: #fee2e2; color: #991b1b; }\n.lm-status.revoked { background: #f1f5f9; color: #475569; }\n.lm-status.paused { background: #fef3c7; color: #92400e; }\n.lm-status.deleted { background: #f3f4f6; color: #9ca3af; }\n\n.lm-body {\n  padding: 12px 16px 14px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.lm-hint {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0 0 10px;\n  line-height: 1.35;\n}\n\n.lm-hint strong {\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.lm-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.lm-stat {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 8px 10px;\n  min-width: 0;\n}\n\n.lm-stat-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  margin-bottom: 2px;\n}\n\n.lm-stat-value {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lm-stat-value.danger { color: #dc2626; }\n.lm-stat-value.ok { color: #059669; }\n.lm-stat-value.mono {\n  font-family: ui-monospace, monospace;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.lm-keys {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.lm-key-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  min-width: 0;\n}\n\n.lm-key-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  width: 72px;\n}\n\n.lm-key-text {\n  flex: 1;\n  font-family: ui-monospace, monospace;\n  font-size: 13px;\n  color: #475569;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.lm-copy-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  border: none;\n  background: none;\n  color: #2563eb;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 2px 4px;\n  flex-shrink: 0;\n}\n\n.lm-copy-btn:hover {\n  color: #1d4ed8;\n}\n\n.lm-activity-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin: 0 0 6px;\n}\n\n.lm-activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.lm-activity-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 8px;\n  background: #f8fafc;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #475569;\n}\n\n.lm-activity-item span:last-child {\n  color: #94a3b8;\n  flex-shrink: 0;\n}\n\n.lm-empty {\n  font-size: 13px;\n  color: #94a3b8;\n  padding: 4px 0;\n}\n\n@media (max-width: 480px) {\n  .lm-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
